import React, { Component } from 'react';
import Md5 from 'crypto-js/md5';

import axios from 'axios'
import {
    StyledCallMeBack,
    StyledCallMeBackFormWrapper,
    StyledCallMeBackForm,
    StyledCallMeBackCloser,
    StyledCallMeBackText,
    StyledCallMeBackFormResponse,
    StyledCallMeBackErrors,
} from './styles';
import { Icons } from '../Icons';
import { ButtonGradient } from '../Buttons';
import { THEME_COLORS } from '../../styles/theme';
import { ButtonLabel } from '../Buttons/labels';
import { ENV_VARIABLES } from '../../envVariables';
import { adfSendEvent } from '../../tracking/adfSendEvent';

export class CallMeBackForm extends Component {
    constructor(props) {
        super(props)

        this.onSubmit = this.onSubmit.bind(this)
        this.toJSONString = this.toJSONString.bind(this)
        this.toggle = this.toggle.bind(this)
        this.onFocus = this.onFocus.bind(this)

        this.state = {
            response: false,
            hasErrors: false,
        }

        this.form = React.createRef()
    }

    onFocus() {
        this.setState({
            hasErrors: false,
        })
    }

    toggle() {
        this.setState({
            response: false,
            hasErrors: false,
        }, () => {
            this.props.toggle();
        });
    }

    toJSONString(form) {
        const obj = {}
        const elements = form.querySelectorAll('input, select, textarea')
        for (let i = 0; i < elements.length; ++i) {
            const element = elements[i]
            const name = element.name
            const value = element.value

            if (name) {
                obj[name] = value
            }
        }

        return obj
    }

    onSubmit(e) {

        const data = this.toJSONString(this.form.current)
        window.callmenow('vivigas')
        const hashedPhones = document.querySelectorAll('[name="PhoneNumber"]')[0]
            .value
        const hashedPhonesMD5 = Md5(hashedPhones).toString()
        window.tC.event.CallMeBackForm(this, { hashed_phone: hashedPhonesMD5 })
        console.log('hash', hashedPhonesMD5)
        console.log('callmenow not defined')
        let errors = 0

        Object.keys(data).map(x => {
            if (data[x] === '') {
                errors = errors + 1
            }
        })

        if (errors > 0) {
            return this.setState({
                hasErrors: true,
            })
        }

        adfSendEvent(this.props.submitStartTrackName)({ sv4: data.nome_cliente, sv5: data.cognome_cliente, sv6: data.numero_telefono });

        const adFormOnCallMeBack = () =>
            adfSendEvent(this.props.submitSuccessTrackName || 'vivigas|click_richiamami_thankyou')(
                { sv4: data.nome_cliente, sv5: data.cognome_cliente, sv6: data.numero_telefono }
            );

        axios({
            method: 'post',
            url: ENV_VARIABLES.callMeBackUrl,
            data,
            config: { headers: { 'Content-Type': 'multipart/form-data' } },
        })
            .then(() => {
                this.setState(
                    {
                        response:
                            'Richiesta ricevuta, sarai richiamato il prima possibile.',
                    },
                    adFormOnCallMeBack,
                )
            })
            .catch((err) => {
                adFormOnCallMeBack();
                this.setState({
                    response: 'Si è verificato un problema, riprova più tardi.',
                })
            })
        return false
    }

    componentDidMount() { }

    render() {
        const { isVisible } = this.props;
        const { response, hasErrors } = this.state;

        return (
            <StyledCallMeBack isVisible={isVisible}>
                <StyledCallMeBackFormWrapper>
                    {response ? (
                        <StyledCallMeBackFormResponse>
                            {response}
                        </StyledCallMeBackFormResponse>
                    ) : (
                            <StyledCallMeBackForm
                                isVisible={isVisible}
                                ref={this.form}
                                onSubmit={this.onSubmit}
                            >
                                <p align="center" >
                                    Il servizio è attivo lun/ven dalle 09:00 alle 20:00
                                    <br />
                                    sabato dalle 10:00 alle 16:00, festività escluse
                                </p>
                                <div>
                                    <div id="CallMeBack">
                                        <table id="tblCallMeBack">
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <label id="lblCallMeBack"></label>
                                                </td>
                                                <td id="colCallMeBack">
                                                    <select id="TimeSlotToCallBack">
                                                    </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <input type="hidden" id="CallType" name="CallType" value="CallMeNow" />
                                    <input type="hidden" id="Customer" name="Customer" placeholder="Customer" />
                                    <input type="hidden" id="Email" name="Email" placeholder="Email" />
                                    <input type="text" id="nome_cliente" name="nome_cliente" placeholder="Nome" />
                                    <input type="text" id="cognome_cliente" name="cognome_cliente" placeholder="Cognome" />
                                    <input type="text" id="PhoneNumber" name="PhoneNumber" placeholder="Phone number" />

                                    <div id="call-processed-advice"></div>
                                    <div className="tp-error"></div>
                                    <div className="tp-success"></div>
                                    <div id="pnz_disclaimer">
                                        <input type="checkbox" style={{display:'none'}} name="privacyConsent" id="privacyConsent" defaultChecked />
                                        <font id="privacytext" style={{display:'none'}}></font>
                                        <div id="privacy-advice"></div>
                                    </div>
                                    <p style={{color: 'white' }}>Proseguendo verrà ricontattato da un operatore di Vivigas S.p.A. <a href="https://www.vivigas.it/normativa/informativa-privacy-ti-chiamiamo-noi" target="_blank">Informativa privacy</a></p>

                                    <button   type="submit"
                                              id="clicktocall"
                                              className="submitcallmeback"
                                              onClick={e => {
                                                  e.preventDefault()
                                                  this.onSubmit()
                                              }}></button>
                                </div>
                            </StyledCallMeBackForm>
                        )}

                    <StyledCallMeBackCloser onClick={this.toggle} isVisible={isVisible}>
                        <Icons icon="Cross" color="white" />
                    </StyledCallMeBackCloser>
                </StyledCallMeBackFormWrapper>
            </StyledCallMeBack>
        )
    }
}